import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header'
import Sidebar from './Sidebar'
import { useAuth } from '../hooks/useAuth'

const Layout: React.FC = () => {
  const { user } = useAuth()
  const location = useLocation()
  
  // Check if this is a share page, login page, or 404 page
  const isSharePage = location.pathname.length === 8 && 
    location.pathname.substring(1).match(/^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]{7}$/)
  const isLoginPage = location.pathname === '/login'
  const is404Page = location.pathname === '/404'
  
  // Mock storage data - in a real app this would come from the server
  const storageUsed = 1.5 * 1024 * 1024 * 1024 // 1.5 GB
  const storageLimit = 10 * 1024 * 1024 * 1024 // 10 GB

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <Header />
      <div className="flex-1 flex overflow-hidden">
        {user && !isSharePage && !isLoginPage && !is404Page && (
          <Sidebar 
            username={user.username} 
            storageUsed={storageUsed} 
            storageLimit={storageLimit} 
          />
        )}
        <main className={`flex-1 overflow-auto ${user && !isSharePage && !isLoginPage && !is404Page ? 'p-0' : ''}`}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default Layout